import { DecimalPipe } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SearchResult } from 'src/app/swagger-api';
import { SearchResultSorting, SortByOptions } from '../../search.enum';

const sortMapping: Record<SortByOptions, SearchResultSorting> = {
  [SortByOptions.NAME_A_Z]: SearchResultSorting.ASCENDING,
  [SortByOptions.NAME_Z_A]: SearchResultSorting.DESCENDING,
  [SortByOptions.NEWEST]: SearchResultSorting.NEWEST,
  [SortByOptions.OLDEST]: SearchResultSorting.OLDEST,
  [SortByOptions.SCORE]: SearchResultSorting.RELEVANCE,
};

@Component({
  selector: 'search-results-shared',
  templateUrl: './search-results-shared.component.html',
  styleUrls: ['./search-results-shared.component.scss'],
  providers: [DecimalPipe],
})
export class SearchResultsSharedComponent {
  @Input() public isLoading = false;
  @Input() public searchResultHint = '';
  @Input() public results: SearchResult[] = [];
  @Input() public selectedSearchOption: SortByOptions;

  @Output() public sortCategory: EventEmitter<string> = new EventEmitter<string>();

  public sortOptions: string[] = [
    SortByOptions.NEWEST,
    SortByOptions.OLDEST,
    SortByOptions.NAME_A_Z,
    SortByOptions.NAME_Z_A,
    SortByOptions.SCORE,
  ];

  public selectOption(option: SortByOptions): void {
    this.selectedSearchOption = option;
    if (this.selectedSearchOption in sortMapping) {
      this.sortCategory.emit(sortMapping[this.selectedSearchOption]);
    }
  }
}
